"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('CONVERSATIONS_LOADED_ACTION', function (recipientEmail, recipientName, conversations) {
    return {
        recipientEmail: recipientEmail,
        recipientName: recipientName,
        conversations: conversations,
    };
});
//# sourceMappingURL=conversationsLoadedAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/actions/conversationsLoadedAction.js
// module id = 2047
// module chunks = 2 3 4 45 108